<template>
  <Panel class="intro-y" :title="$t('text.customerInfoFinancial')">
    <div class="flex flex-col sm:flex-row">
      <p class="mr-auto text-gray-600">{{ $t('text.haveSocialInsurance') }}</p>
      <p class="font-medium">{{ customer.socialInsurance ? $t('text.yes') : $t('text.no') }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.haveAnotherLoan') }}</p>
      <p class="font-medium">{{ customer.isLoan ? $t('text.yes') : $t('text.no') }}</p>
    </div>
    <div v-if="customer.leasingPaymentMonth" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.monthlyLoanAmount') }}</p>
      <p class="font-medium">{{ customer.leasingPaymentMonth }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.haveCar') }}</p>
      <p class="font-medium">{{ customer.isCar ? $t('text.yes') : $t('text.no') }}</p>
    </div>
    <div v-if="customer.monthlySalary" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.monthlyIncome') }}</p>
      <p class="font-medium">{{ customer.monthlySalary }}</p>
    </div>
    <div v-if="customer.jobType" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.currentIndustry') }}</p>
      <p class="font-medium">{{ customer.jobType.name }}</p>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.totalYearsWorked') }}</p>
      <p class="font-medium">{{ parseInt(customer.totalYearWork, 10) }}</p>
    </div>
    <div v-if="customer.companyName" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.nameOfCurrentOrganization') }}</p>
      <p class="font-medium">{{ customer.companyName }}</p>
    </div>
    <div v-if="customer.totalYearWorkingCompany" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.totalYearsWorkedCurrentOrganization') }}</p>
      <p class="font-medium">{{ parseInt(customer.totalYearWorkingCompany, 10) }}</p>
    </div>
    <div v-if="customer.positionType" class="flex flex-col sm:flex-row mt-5">
      <p class="mr-auto text-gray-600">{{ $t('text.currentWorkPosition') }}</p>
      <p class="font-medium">{{ customer.positionType.name }}</p>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';

export default {
  props: {
    customer: Object,
  },
  components: { Panel },
};
</script>
